module.exports = __webpack_public_path__ + "static/media/spam-tab-active.1af5263a.svg";